export const myDynosFields = `
    id
    dynoTitle
    description
    accessType
    createdAt
    updatedAt
    owner {
        id
        firstName
        lastName
    }
    dynoPublishingStatus
    dynoType {
        id
        name
    }
    category {
        id
        name
    }
`;

export const userFields = `
    id
    firstName
    lastName
    email
    userAccountType {
      userAccountType
      id
    }
    userRole {
      id
      role
    }
    organizations {
        id
        name
        email
    }
    loginCount
    aboutMe
    otherInfo
`;

export const standardFields = `
    id
    name
    description
`;

export const asnFields = `
    id
    asnID
    type
    authorityStatus {
        id
        asnID
        title
        publicationStatus
        valid
        jurisdiction {
            id
            name
            description
        }
    }
    indexingStatus
    statementNotation
    listID
`;

export const productCategoryFields = `
    id
    name
    parentCategory {
        id
        name
        createdAt
        updatedAt
    }
    createdAt
    updatedAt
`;

export const dynoListFields = `
    id
    listName
    listTitle
    listSubTitle
    listDescription
    listCoverPath
    dynosUnderList {
        ${myDynosFields}
    }
    printChapterPage
    createdAt
    updatedAt
`;

export const productFields = `
    id
    productName
    productType
    productHeading
    productSubHeading
    productAdmins {
        ${userFields}
    }
    productDescription
    productCategory {
        ${productCategoryFields}
    }
    productSubjects {
        id
        name
    }
    productStandards {
        id
        name
        description
    }
    productDetailedStandards {
        id
        name
        standard {
            id
            name
            description
        }
        grade
        subject
        createdAt
        updatedAt
    }
    productCoverPath
    productStatus
    productPricingType
    productFreePlan {
        id
        planName
        planShortDescription
        planLongDescription
        AccessUntil
        createdAt
        updatedAt
    }
    productOneTimePlan {
        id
        planName
        price
        planShortDescription
        planLongDescription
        createdAt
        updatedAt
    }
    productSubscriptionPlan {
        id
        planName
        price
        planShortDescription
        planLongDescription
        frequency
        createdAt
        updatedAt
    }
    productPaymentsPlan {
        id
        planName
        price
        planShortDescription
        planLongDescription
        noOfMonthlyPayments
        createdAt
        updatedAt
    }
    productContent {
        id
        dynoList {
            ${dynoListFields}
        }
    }
    createdAt
    updatedAt
`;

export const catalogFields = `
    id
    catalogName
    heading
    subHeading
    catalogCoverPath
    catalogAdmins {
        ${userFields}
    }
    description
    catalogStatus
    products {
        ${productFields}
    }
    createdAt
    updatedAt

`;
